import { css } from '@emotion/react';
import React from 'react';

const convertNumberStringCss = (value: number | string) =>
  value === 0 ? '0' : typeof value === 'number' ? `${value}px` : value;

type HorizontalPosition = 'left' | 'right';
type VerticalPosition = 'top' | 'bottom';

export interface UnreadBadgeProps {
  count: number;
  horizontalPosition?: HorizontalPosition;
  verticalPosition?: VerticalPosition;
  horizontalOffset?: number | string;
  verticalOffset?: number | string;
}

export const UnreadBadge = ({
  count,
  horizontalPosition = 'right',
  verticalPosition = 'top',
  horizontalOffset = 0,
  verticalOffset = 0,
}: UnreadBadgeProps) => {
  if (count === 0) return null;

  const horizontal = `${horizontalPosition}: ${convertNumberStringCss(horizontalOffset)};`;
  const vertical = `${verticalPosition}: ${convertNumberStringCss(verticalOffset)};`;

  return (
    <div
      css={(theme) => css`
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        ${horizontal}
        ${vertical}
        background: ${theme.canary};
        color: ${theme.midnight};
        width: 12px;
        height: 12px;
        font-weight: 700;
        font-size: 10px;
        border-radius: 50px;
      `}
      aria-label={`${count} unread options`}
    >
      {count > 9 ? '9+' : count}
    </div>
  );
};
